export default {
  title: 'Discounts and payment methods',
  headers: {
    type: 'Type',
    class: 'Discount/Charge class',
    description: 'Description',
    base: 'Base',
    percent: '(%)',
    amount: 'Amount',
    document: 'Issuer document',
    date: 'Date',
    serie: 'Series and number'
  }
}
